/**
 * Converts list into array
*/
module.exports = function toArray(list) {
  return Array.prototype.slice.call(list || [], 0);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/toArray.js
// module id = 1376
// module chunks = 0